"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGoogleDocument = void 0;
function isGoogleDocument(url) {
    return /https:\/\/docs\.google\.com\/(?<type>document|spreadsheets)\/d/.test(url);
}
exports.isGoogleDocument = isGoogleDocument;
